"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _modal = require("@amzn/meridian/modal");
var _row = _interopRequireDefault(require("@amzn/meridian/row"));
var _button = _interopRequireDefault(require("@amzn/meridian/button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ButtonWithToolTip = _interopRequireDefault(require("./ButtonWithToolTip"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var NonSkippableFooter = function NonSkippableFooter(_ref) {
  var isDisabled = _ref.isDisabled,
    onClickFooterButton = _ref.onClickFooterButton,
    submitButtonSize = _ref.submitButtonSize,
    submitButtonType = _ref.submitButtonType,
    submitButtonText = _ref.submitButtonText;
  return /*#__PURE__*/_react["default"].createElement(_modal.ModalFooter, null, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    alignmentHorizontal: "center",
    widths: "fit"
  }, isDisabled ? /*#__PURE__*/_react["default"].createElement(_ButtonWithToolTip["default"], {
    onClickFooterButton: onClickFooterButton,
    title: _FeedbackConstants.REQUIRED_QUESTION_TITLE,
    submitButtonSize: submitButtonSize,
    submitButtonType: submitButtonType,
    submitButtonText: submitButtonText
  }) : /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: submitButtonType,
    size: submitButtonSize,
    onClick: onClickFooterButton
  }, submitButtonText)));
};
NonSkippableFooter.propTypes = {
  isDisabled: _propTypes["default"].bool.isRequired,
  onClickFooterButton: _propTypes["default"].func.isRequired,
  submitButtonSize: _propTypes["default"].string,
  submitButtonType: _propTypes["default"].string,
  submitButtonText: _propTypes["default"].string
};
NonSkippableFooter.defaultProps = {
  submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text
};
var _default = exports["default"] = NonSkippableFooter;
//# sourceMappingURL=NonSkippableFooter.js.map